import { FC } from 'react';

type InputLabelProps = {
  label: string;
  htmlFor: string;
};

const InputLabel: FC<InputLabelProps> = ({ label, htmlFor }) => {
  return (
    <label
      htmlFor={htmlFor}
      className="flex align-self-start text-xs mb-1 text-600"
    >
      {label}
    </label>
  );
};

export default InputLabel;
